import { FreeTrialButton } from "../free-trial-button";
import { RequestDemoButton } from "../request-demo-button";

export const Actions = () => {
  return (
    <div
      css={`
        padding: 0 20px 16px;
        display: flex;
        flex-direction: column;
        gap: 16px;

        @media (min-width: 960px) {
          padding: 0;
          flex-direction: row;
        }
      `}
    >
      <FreeTrialButton />
      <RequestDemoButton />
    </div>
  );
};
